<template>
    <div>
        <vSelect :options="languageOptions" v-model="language" :reduce="label => label.code" label="label"/>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
    name: "LanguageSelect",
    components: {
        vSelect
    },
    props: {
        value: String

    },
    data() {
        return {
            systemLangs: []
        }
    },
    computed: {
        languageOptions: function() {
            var ret = [];

            /*
            if( this.systemLangs )
                for( var a of this.systemLangs ) {
                         ret.push({code: a.id, label:this.$t(a.lang)});
               ret.push({code: a.id, label:this.$t(a.lang)});
                }
            */
            ret.push({ code: "fi", label: "fi" });
            ret.push({ code: "en", label: "en" });
            ret.push({ code: "pl", label: "pl" });
       
            return ret;
        },
        language: {
            get: function() { return this.value },
            set: function( newValue ) { 
                this.$emit('input' , newValue )}
        }
    },
    mounted() {
        if (!this.systemLangs || this.systemLangs.length === 0)
         
            this.$store.dispatch('getSystemParameters').then((result) => {
                var langs = [];
                Object.keys(result.system_languages).forEach(item => langs.push({"id": item, "lang": result.system_languages[item]}))
                    this.systemLangs = langs;

            });

   }
}
</script>